import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class BeneficioService extends BaseService {
  getBase() {
    let url = environment.portalApi + '/Benefit/GetBase';
    return this.http.get(url, { headers: this.createHeader() });
  }
  getPdf(id: any) {
    let url = environment.portalApi + '/Benefit/GetSolicitationPdf/' + id;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
  getSolicitations() {
    let url = environment.portalApi + '/Benefit/GetSolicitations?';
    return this.http.get(url, { headers: this.createHeader() });
  }
  getFile(dataDownload: any) {
    let url = environment.portalApi + '/Benefit/GetFile?' + this.paramsToQueryString(dataDownload);
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
  postSalvarBeneficio(model: any) {
    let url = environment.portalApi + '/Benefit/SaveSolicitation';
    return this.http.post(url, model, { headers: this.createHeader() });
  }
  deleteCancelar(id: any) {
    let url = environment.portalApi + `/Benefit/CancelSolicitation/` + id;
    return this.http.delete(url, { headers: this.createHeader() });
  }
  postBenefit(model: any) {
    let url = environment.portalApi + '/Benefit/SaveSolicitation';
    return this.http.post(url, model, { headers: this.createHeader() });
  }
  putBenefit(model: any) {
    let url = environment.portalApi + '/Benefit/UpdateSolicitation';
    return this.http.put(url, model, { headers: this.createHeader() });
  }
  getBenefits(filter: any) {
    let url = environment.portalApi + '/Benefit/GetSolicitations?' + this.paramsToQueryString(filter);
    return this.http.get(url, { headers: this.createHeader() });
  }
}
